import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPicpayComponent } from './simple-icons-picpay.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPicpayComponent ],
    exports:      [ SimpleIconsPicpayComponent ],
    bootstrap:    []
})
export class SimpleIconsPicpayModule {}
